import { ELedgerQueueDto } from '@/@apis/cloud-api'
import { CreateBackupQueueResponse } from '@/@apis/desktop-api'
import { DataTable } from '@/components/shared'
import Button from '@/components/ui/Button'
import Dialog from '@/components/ui/Dialog'
import { pathProxy } from '@/utils/pathProxy'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useTranslation } from 'react-i18next'
import { CgCloseO } from 'react-icons/cg'
import { HiOutlineExclamation } from 'react-icons/hi'
import Avatar from '../Avatar'
import Tabs from '../Tabs'
import TabContent from '../Tabs/TabContent'
import TabList from '../Tabs/TabList'
import TabNav from '../Tabs/TabNav'
import Tag from '../Tag'
import BackupResponseErrorDetailModal from './BackupResponseErrorDetailModal'

interface ConfirmDialogProps {
   eLedgerQueueDto: ELedgerQueueDto
}

const _d = pathProxy<CreateBackupQueueResponse>()

const BackupQueueDetailModal = NiceModal.create(({ eLedgerQueueDto }: ConfirmDialogProps) => {
   const modal = useModal()

   const { t } = useTranslation(undefined, { keyPrefix: 'components.shared.errorDialog' })

   const handleCancel = () => {
      modal.hide()
   }

   return (
      <Dialog
         shouldCloseOnEsc={true}
         shouldCloseOnOverlayClick={true}
         width={900}
         onClose={handleCancel}
         onRequestClose={handleCancel}
         isOpen={modal.visible}
      >
         <div className=" pb-6 pt-2 flex items-center">
            <div>
               <Avatar className="text-cyan-600 bg-cyan-100 dark:text-cyan-100" shape="circle">
                  <span className="text-2xl">
                     <HiOutlineExclamation />
                  </span>
               </Avatar>
            </div>
            <div className="ml-4 rtl:mr-4">
               <h5 className="mb-2">Yükleme Sonucu</h5>
            </div>
         </div>

         <Tabs defaultValue="tab1" variant="pill">
            <TabList>
               <TabNav value="tab1">Başarılı Kayıtlar</TabNav>
               <TabNav value="tab2">Başarısız Kayıtlar</TabNav>
            </TabList>
            <div className="py-4">
               <TabContent value="tab1" style={{ overflowY: 'auto', maxHeight: '400px' }}>
                  <DataTable<string>
                     columns={[
                        {
                           header: 'Dosya Adı',
                           accessorKey: _d.fileName!._PATH_,
                           enableSorting: false,
                           size: null as any,
                        },
                     ]}
                     data={(JSON.parse(eLedgerQueueDto.eLedgerBackupSuccededFiles!) as string[]).map((i) => {
                        return { fileName: i }
                     })}
                     loading={false}
                     pagingData={undefined}
                  />
               </TabContent>
               <TabContent value="tab2">
                  <DataTable<CreateBackupQueueResponse>
                     columns={[
                        {
                           header: 'Dosya Adı',
                           accessorKey: _d.fileName!._PATH_,
                           enableSorting: false,
                           size: null as any,
                        },
                        {
                           header: 'İşlem Sonucu',
                           accessorKey: _d.succeded!._PATH_,
                           enableSorting: false,
                           size: 220,
                           cell: (props) => {
                              const data = JSON.parse((props.row.original as any).message)

                              return (
                                 <Tag
                                    className="cursor-pointer bg-red-100 text-red-600 dark:bg-red-500/20 dark:text-red-100  border-0 rounded cursor-pointer"
                                    onClick={() =>
                                       NiceModal.show(BackupResponseErrorDetailModal, {
                                          createBackupQueueResponse: {
                                             fileName: props.row.original.fileName,
                                             errorDescription: data.message,
                                             schemaErrors: JSON.parse(data.schemaErrors),
                                             schematronErrors: JSON.parse(data.schematronErrors),
                                          },
                                       })
                                    }
                                 >
                                    Hata detay için tıklayınız.
                                 </Tag>
                              )
                           },
                        },
                     ]}
                     data={JSON.parse(eLedgerQueueDto.eLedgerBackupErrorFiles!)}
                     loading={false}
                     pagingData={undefined}
                  />
               </TabContent>
            </div>
         </Tabs>

         <div className="text-right mt-6">
            <Button className="ltr:mr-2 rtl:ml-2" variant="twoTone" color="red-600" onClick={handleCancel} icon={<CgCloseO />}>
               {t('cancelButton')}
            </Button>
         </div>
      </Dialog>
   )
})

export default BackupQueueDetailModal
